import { getCountryByDomain } from './location';
export function getApiBaseUrl() {
  const country = getCountryByDomain();
  switch (country?.val) {
    case 'tr':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_TR;
    case 'az':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_AZ;
    case 'kz':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_KZ;
    case 'kg':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_KG;
    case 'ge':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_GE;
    case 'iq':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_IQ;
    case 'uz':
      return process.env.NEXT_PUBLIC_REST_API_ENDPOINT_UZ;
  }
}
